import React from "react";
import get from "lodash/get";

import StarRating from "../../../atoms/star-rating";

import "./gadget-review.m.css";

const GadgetReviewView = ({ story }) => {
  const MetaData = get(story, ["metadata"]);
  const gadgetName = get(MetaData, ["gadget-name"], "");
  const feature1 = get(MetaData, ["feature1"], "");
  const feature2 = get(MetaData, ["feature2"], "");
  const feature3 = get(MetaData, ["feature3"], "");
  const rating = get(MetaData, ["rating"], "");

  return (
    <div styleName="wrapper">
      <div styleName="text-and-rating">
        <div styleName="title-wrapper">
          <div styleName="title">{gadgetName}</div>
        </div>
        <StarRating rating={rating} />
      </div>
      <div styleName="top-features">ಟಾಪ್ ಫೀಚರ್ಸ್</div>
      <ul styleName="details">
        <li>
          <div styleName="disc"></div>
          {feature1}
        </li>
        <li>
          <div styleName="disc"></div>
          {feature2}
        </li>
        <li>
          <div styleName="disc"></div>
          {feature3}
        </li>
      </ul>
    </div>
  );
};

export default GadgetReviewView;
